module.exports = __webpack_public_path__ + "img/accountTransactions.990ab709.svg";